import React from 'react';
import RenewButton from './RenewButton';
import { refreshCoreAuth, refreshSchedules, refreshStations } from '../../../../services/admin/refreshService';
import useTranslation from '../../../hooks/translation/useTranslation';

function Renew() {
  const { trans } = useTranslation();
  const renews = [
    {
      title: trans('stations'),
      service: refreshStations,
    },
    {
      title: trans('schedule'),
      service: refreshSchedules,
    },
    {
      title: trans('authorization'),
      service: refreshCoreAuth,
    },
  ];

  return (
    <div className="flex flex-col gap-4">
      {
        renews?.map((renew) => (
          <RenewButton
            key={renew.title}
            title={renew.title}
            renewService={renew.service}
          />
        ))
      }
    </div>
  );
}

export default Renew;
